import { ReactElement } from 'react';
import { isArray } from 'lodash';

import { getSharedArray } from '../../../getters';
import { SitecoreItem } from '../../../types';
import { CampaignCard } from '../MegaMenuTypes';
import {
  getCardsContainerGridColumnsClass,
  groupNonCampaignCards,
  isCampaignCard,
} from '../MegaMenuUtils';
import { useHeaderNavigation } from '../providers';
import { BigCard } from './BigCard';
import { Campaigns } from './Campaigns';
import { SmallCardsGroup } from './SmallCardsGroup';

import styles from './Cards.module.css';

export const MajorLinkCards = (): ReactElement | null => {
  const { activeMajorLink } = useHeaderNavigation();

  if (!activeMajorLink) {
    return null;
  }

  const cards = getSharedArray(activeMajorLink.fields, 'Cards');

  if (!cards || cards.length === 0) {
    return null;
  }

  const campaigns = cards.filter((card) => isCampaignCard(card)) as SitecoreItem<CampaignCard>[];
  const nonCampaigns = groupNonCampaignCards(cards.filter((card) => !isCampaignCard(card)));

  return (
    <div className={styles.gridBase} id="categories">
      <div
        className={`${getCardsContainerGridColumnsClass(nonCampaigns.length)} ${styles.gridBase}`}
      >
        {nonCampaigns.map((item, index) => {
          if (isArray(item)) {
            return <SmallCardsGroup items={item} key={`${item.length} ${index}`} />;
          } else {
            return <BigCard data={item} key={`${item.id} ${index}`} />;
          }
        })}
      </div>
      {campaigns && campaigns.length > 0 ? <Campaigns items={campaigns} /> : null}
    </div>
  );
};
